import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "request col-4 mx-auto mb-4 mt-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "確認コード入力")
], -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", { class: "fw-bold" }, "メールアドレスの変更は完了していません。", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "入力されたメールアドレスが有効であることを確認します。", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", { class: "form-text text-muted" }, "メールに記載されている確認コードを入力してください。", -1)
const _hoisted_9 = { class: "d-flex justify-content-evenly mt-5 mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary col-4",
  type: "submit"
}, "確認コード送信", -1)

import { useMessenger } from '@/plugins/message'
import { useNicotto } from '@/plugins/nicotto'
import FormGroup from "@/components/ui/FormGroup.vue";
import InputText from "@/components/ui/InputText.vue";
import { useRouter } from "vue-router";
import { useStore } from '@/store'
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountConfirmView',
  setup(__props) {

const messenger = useMessenger()
const router = useRouter()
const nicotto = useNicotto()
const store = useStore()
const email = store.state.email
const code = ref('')

const sendCode = async() => {
  try {
    await nicotto.auth.completeEmailChange(code.value)
    messenger.set('user.updateSucceeded')
    store.commit("setEmail", null)
    router.push('/')
  } catch (err) {
    console.log(err)
    messenger.set('code.authenticationFailed')
  }
}
const resendCode = async() => {
  try {
    await nicotto.auth.updateEmail(email)
    messenger.set('code.resendSucceeded')
  } catch (err) {
    console.log(err)
    messenger.set('code.resendFailed')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (sendCode()), ["prevent"])),
          novalidate: ""
        }, [
          _hoisted_5,
          _createVNode(FormGroup, {
            label: "確認コード",
            "label-for": "code",
            horizontal: false,
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createVNode(InputText, {
                label: "確認コード",
                id: "code",
                modelValue: code.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_6,
              _hoisted_7,
              _hoisted_8
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btn btn-light col-4",
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (resendCode()))
            }, "確認コード再送"),
            _hoisted_10
          ])
        ], 32)
      ])
    ])
  ]))
}
}

})